var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterested(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.746,
    cy: 42.207,
    r: 42.18,
    fill: "red"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.78 68.463c.498-.273 1.005-.536 1.512-.8 1.121-.582 2.245-1.166 3.294-1.855 4.993-3.317 9.308-7.334 12.522-12.421 1.651-2.617 2.84-5.418 3.243-8.501.915-7.023-3.813-12.353-9.966-13.024-.364-.039-.403-.194-.403-.496 0-.452.002-.904.005-1.357.007-1.36.015-2.723-.044-4.08-.226-5.32-4.512-9.61-9.859-9.96-5.406-.35-10.232 3.385-11.166 8.647-.098.564-.127 1.157-.147 1.731-.02.817.511 1.372 1.258 1.4.777.03 1.337-.515 1.366-1.351.099-2.636 1.15-4.815 3.342-6.342 2.595-1.8 5.406-2.023 8.227-.613 2.811 1.401 4.246 3.784 4.354 6.887.04 1.24.03 2.48.02 3.737-.005.576-.01 1.155-.01 1.739-3.184.399-5.829 1.78-7.922 4.163-.21-.19-.415-.38-.617-.57-.412-.386-.816-.764-1.25-1.103-4.817-3.774-11.884-3.414-16.061.836-2.28 2.315-3.273 5.126-3.195 8.336.08 3.22 1.17 6.147 2.753 8.919 2.595 4.552 6.211 8.21 10.32 11.429 1.976 1.546 4.05 2.966 6.33 4.065.279.135.565.25.852.367.169.067.337.135.504.207.256.01.492.01.737.01Zm-.394-25.58c-1.69 0-3.056 1.351-3.056 3.024a3.02 3.02 0 0 0 1.238 2.432l-.963 6.818h5.573l-.973-6.828a3.001 3.001 0 0 0 1.238-2.422c0-1.673-1.366-3.025-3.057-3.025Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 64.469 15.95)",
    d: "M0 0h42.176v52.513H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterested);
export default __webpack_public_path__ + "static/media/interested.76ee959503e64425850ad5cdc3d4e4a3.svg";
export { ForwardRef as ReactComponent };